import { Fade } from "@material-ui/core";
import { Icon, Link } from "@resource/atlas";
import { atlasBookOpen } from "@resource/atlas/icons";
import { useFlags } from "@resource/client-ffs";
import { useAuthContext } from "auth/context";
import clsx from "clsx";
import layoutStyles from "components/legacy/GuidesHomepage/Settings/Settings.module.scss";
import TabRouter from "components/legacy/TabRouter";
import ModalProvider from "components/ModalProvider";
import FeatureFlags from "generated/FeatureFlags";
import { ReactNode, useMemo } from "react";
import { formatEntity } from "shared/constants/entities";
import {
  GUIDE_TEMPLATES_TUTORIAL,
  MESSAGE_TEMPLATES_TUTORIAL,
} from "utils/constants/href";

function SettingsLayout({ children }: { children?: ReactNode }) {
  const {
    [FeatureFlags.USE_GUIDE_TEMPLATES]: useGuideTemplates,
    [FeatureFlags.NEW_INTERVIEW_TEMPLATES]: interviewTemplatesEnabled,
  } = useFlags();
  const {
    zeusInfo: { isZeusTransition, isZeusFeatureEnabled, isZeus },
  } = useAuthContext();

  return (
    <Fade in timeout={500}>
      <ModalProvider>
        <div className={layoutStyles.settingsContainer}>
          {interviewTemplatesEnabled && (
            <div className="mb-8">
              <div
                className={clsx("text-display-2 dark", {
                  "mb-4": isZeusFeatureEnabled || useGuideTemplates,
                })}
              >
                Templates
              </div>
              <div className="text-body-md flex space-x-4">
                {useGuideTemplates && (
                  <Link href={GUIDE_TEMPLATES_TUTORIAL} target="_blank">
                    <Icon content={atlasBookOpen} className="inline mr-2" />
                    How to use {formatEntity("job template", { plural: true })}
                  </Link>
                )}
                {isZeusFeatureEnabled && (
                  <Link href={MESSAGE_TEMPLATES_TUTORIAL} target="_blank">
                    <Icon content={atlasBookOpen} className="inline mr-2" />
                    How to use {formatEntity("message")} templates
                  </Link>
                )}
              </div>
            </div>
          )}
          <TabRouter
            routes={useMemo(
              () => [
                ...(useGuideTemplates
                  ? [
                      {
                        path: "/templates/guides",
                        label: formatEntity("job template", {
                          plural: true,
                          capitalize: true,
                        }),
                      },
                    ]
                  : []),
                ...(isZeusFeatureEnabled
                  ? [
                      {
                        path: "/templates/messages",
                        label: isZeusTransition
                          ? `${formatEntity("message", {
                              capitalize: true,
                            })} templates (beta)`
                          : `${formatEntity("message", {
                              capitalize: true,
                            })} templates`,
                      },
                    ]
                  : []),
                ...(!isZeus
                  ? [
                      {
                        path: "/templates/content",
                        label: "Content templates",
                      },
                    ]
                  : []),
                ...(!isZeus
                  ? [
                      {
                        path: "/templates/emails",
                        label: "Email templates",
                      },
                    ]
                  : []),
              ],
              [
                useGuideTemplates,
                isZeusFeatureEnabled,
                isZeusTransition,
                isZeus,
              ]
            )}
            useAtlas={interviewTemplatesEnabled}
          >
            {children}
          </TabRouter>
        </div>
      </ModalProvider>
    </Fade>
  );
}

export default SettingsLayout;
